import { Fragment } from 'react'

import { press, smooth, step } from '../springs'
import { Avatar, I, Icon, at, show } from './common'

/*
 * Szene 3: HR markiert die drei besten Talente als qualifiziert und lädt sie
 * zum Interview ein. Danach wird Lena eingestellt.
 */

const PEOPLE = [
  ['Lena M.', 82],
  ['Jonas P.', 78],
  ['Mia K.', 74],
  ['Can Y.', 61]
]
const LROW = (i) => -66 + i * 52
export const CHECKS = [24, 24.5, 25]
export const CHECK_BOX = (i) => [-248, LROW(i)]
export const LIST_BTN = [-176, 142]
export const LIST_AT = 26
export const HIRE_BTN = [-58, 66]
export const HIRE_AT = 28.75

function List() {
  return (
    <>
      <span className='mo-h' style={at(-256, -156)}>
        Talente
      </span>
      <span className='mo-sub' style={at(-256, -130)}>
        Account Manager Vertrieb · 24 eingeladen
      </span>
      <span
        className='mo-badge mo-badge--blue mo-right'
        data-mo='ls-count'
        style={at(256, -152)}
      >
        0 ausgewählt
      </span>
      <span className='mo-cap mo-cap--muted' style={at(-226, -104)}>
        Name
      </span>
      <span className='mo-cap mo-cap--muted' style={at(32, -104)}>
        Score
      </span>
      <span className='mo-cap mo-cap--muted mo-right' style={at(256, -104)}>
        Status
      </span>
      {PEOPLE.map(([name, score], i) => (
        <Fragment key={name}>
          <span
            className='mo-rule'
            style={{ ...at(-280, LROW(i) - 26), width: 560 }}
          />
          <span
            className='mo-check'
            data-mo='ls-box'
            style={at(-256, LROW(i) - 8)}
          >
            <Icon d={I.check} size={12} stroke='#FFFFFF' width={2.5} />
          </span>
          <Avatar
            name={name}
            size={32}
            tone='light'
            style={at(-226, LROW(i) - 16)}
          />
          <span className='mo-title' style={at(-184, LROW(i) - 10)}>
            {name}
          </span>
          <span className='mo-title' style={at(32, LROW(i) - 10)}>
            {score}
          </span>
          <span className='mo-mini' style={at(62, LROW(i) - 3)}>
            <i style={{ width: `${score}%` }} />
          </span>
          <span
            className='mo-badge mo-badge--green mo-right'
            data-mo='ls-done'
            style={at(256, LROW(i) - 11)}
          >
            Abgeschlossen
          </span>
          <span
            className='mo-badge mo-badge--yellow mo-right'
            data-mo='ls-qual'
            style={at(256, LROW(i) - 11)}
          >
            Qualifiziert
          </span>
        </Fragment>
      ))}
      <span className='mo-btn' data-mo='ls-btn' style={at(-256, 124)}>
        Zum Interview einladen
        <Icon d={I.arrow} size={16} width={2} />
      </span>
    </>
  )
}

function Interviews() {
  return (
    <>
      <span className='mo-ic mo-ic--blue' style={at(-182, -18)}>
        <Icon d={I.calendar} size={18} />
      </span>
      <span className='mo-title' style={at(-132, -19)}>
        3 Talente qualifiziert
      </span>
      <span className='mo-sub' style={at(-132, 1)}>
        Einladungen zum Interview verschickt
      </span>
    </>
  )
}

function Hire() {
  return (
    <>
      <Avatar name='Lena M' size={56} tone='blue' style={at(-206, -94)} />
      <span className='mo-h' style={at(-136, -90)}>
        Lena M.
      </span>
      <span className='mo-sub' style={at(-136, -64)}>
        Account Manager Vertrieb
      </span>
      <span className='mo-meta' style={at(-206, -18)}>
        Status
      </span>
      <span
        className='mo-badge mo-badge--yellow'
        data-mo='hr-before'
        style={at(-206, 0)}
      >
        Qualifiziert
      </span>
      <span
        className='mo-badge mo-badge--green'
        data-mo='hr-after'
        style={at(-206, 0)}
      >
        Eingestellt
      </span>
      <span className='mo-meta' style={at(-60, -18)}>
        Passung zur Stelle
      </span>
      <span className='mo-badge mo-badge--fit' style={at(-60, 0)}>
        82 · Sehr passend
      </span>
      <span className='mo-btn mo-btn--sec' style={at(-206, 48)}>
        Absagen
      </span>
      <span className='mo-btn' data-mo='hr-btn' style={at(-108, 48)}>
        <Icon d={I.check} size={16} width={2} />
        Einstellen
      </span>
    </>
  )
}

function Welcome() {
  return (
    <>
      <span className='mo-ic mo-ic--green' style={at(-182, -18)}>
        <Icon d={I.check} size={18} width={2} />
      </span>
      <span className='mo-title' style={at(-132, -19)}>
        Lena M. ist eingestellt
      </span>
      <span className='mo-sub' style={at(-132, 1)}>
        Willkommen im Team Vertrieb
      </span>
    </>
  )
}

export const HIRE_CONTENTS = {
  list: List,
  interviews: Interviews,
  hire: Hire,
  welcome: Welcome
}

export function buildHire({ q, qa }) {
  const count = q('ls-count')
  const boxes = qa('ls-box')
  const done = qa('ls-done')
  const qual = qa('ls-qual')
  const btn = q('ls-btn')
  const before = q('hr-before')
  const after = q('hr-after')
  const hireBtn = q('hr-btn')

  return (t) => {
    // Drei Haken auf dem Beat, der Status springt auf „Qualifiziert“
    const n = CHECKS.filter((c) => t >= c).length
    count.textContent = `${n} ausgewählt`
    boxes.forEach((box, i) => {
      const c = CHECKS[i]
      const on = c !== undefined && t >= c
      box.style.backgroundColor = on ? '#4461D4' : '#FFFFFF'
      box.style.boxShadow = on ? 'none' : 'inset 0 0 0 1px #D1DBE6'
      box.firstChild.style.opacity = on ? '1' : '0'
      const k = c === undefined ? 0 : press(t, c - 0.06)
      box.style.transform = `scale(${(1 - 0.15 * k).toFixed(3)})`
      const v = c === undefined ? 0 : smooth((t - (c + 0.05)) / 0.18)
      show(done[i], 1 - v, 6)
      show(qual[i], v, 6)
      qual[i].style.transform =
        `translateX(-100%) scale(${(0.85 + 0.15 * (c === undefined ? 1 : step(t - c, 20, 0.75))).toFixed(3)})`
    })
    show(btn, smooth((t - 25.2) / 0.22))
    btn.style.transform = `scale(${(1 - 0.05 * press(t, LIST_AT - 0.06)).toFixed(3)})`

    // Einstellen: Status wechselt auf „Eingestellt“
    show(before, 1 - smooth((t - HIRE_AT) / 0.16), 6)
    show(after, smooth((t - (HIRE_AT + 0.08)) / 0.18), 6)
    after.style.transform = `scale(${(0.85 + 0.15 * step(t - HIRE_AT, 20, 0.75)).toFixed(3)})`
    hireBtn.style.transform = `scale(${(1 - 0.05 * press(t, HIRE_AT - 0.06)).toFixed(3)})`
  }
}

export const HIRE_IDS = Object.keys(HIRE_CONTENTS)
